import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from './Button';

const Logout = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await fetch('https://crtapp.xyz/api/logout', {
        method: 'POST',
        credentials: 'include'
      });
    } catch (err) {
      console.error('Logout request failed:', err);
    }

    // Clear all stored user info
    sessionStorage.removeItem('user');
    localStorage.removeItem('token');

    // Redirect to login page
    navigate('/');
  };

  return (
    <div className="logout-container">
      <Button onClick={handleLogout} className="logout-button">
        Logout
      </Button>
    </div>
  );
};

export default Logout;